import React, { useEffect, useImperativeHandle } from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import jwt_decode from "jwt-decode";
import Collapse from "@material-ui/core/Collapse";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

// @material-ui/icons
import Language from "@material-ui/icons/Language";
import Phone from "@material-ui/icons/Phone";
import Person from "@material-ui/icons/Person";
import ListIcon from "@material-ui/icons/Reorder";
import FAQIcon from "components/CustomIcons/FAQ.js";

import styles from "assets/jss/material-dashboard-pro-react/components/guestNavbarStyle.js";
import logo from "assets/img/logo.png";
import logoArriba from "assets/img/logo_2.png";
import logoFreeway from "assets/img/logo_4.png";
import logo4 from "assets/img/logo_4.png";
import { useTranslation } from "react-i18next";
import CustomSelect from "components/CustomSelect/CustomSelect.js";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { ClassNames } from "@emotion/react";
import { current } from "@reduxjs/toolkit";
import GridContainer from "components/Grid/GridContainer";
import { Grid } from "react-loader-spinner";
import GridItem from "components/Grid/GridItem";
import { useInactivity } from "components/Inactivity/Inactivity";
import { checkIfIsKiosko, isAgent } from "components/Utils/utils";

import MenuButton from "components/MenuButton/MenuButton";

import mexFlag from "assets/img/mexFlag.svg";
import usFlag from "assets/img/usaFlag.svg";

import "../../assets/css/freewayStyle.css";

const useStyles = makeStyles(styles);

export default function AuthNavbar(props) {
  const { t, i18n } = useTranslation();
  const { color, brandText, handleDrawerToggle, agencyType } = props;
  const [openAvatar, setOpenAvatar] = React.useState(false);

  const isInactive = useInactivity();

  const pathName = window.location.pathname;

  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;
    i18n.changeLanguage(selectedLanguage);
  };

  const isKiosko = checkIfIsKiosko();

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));

  const userType = localStorage.getItem("userType");
  const token = localStorage.getItem("userToken");

  const logoList = {
    Sanborns: logo,
    Freeway: logoFreeway,
    Arriba: logoArriba,
  };

  var decoded = token !== null ? jwt_decode(token) : { username: "none" };
  const userName = decoded.username;

  const urlSegments = window.location.pathname.split("/");
  const lastSegment = urlSegments[urlSegments.length - 1];

  const changeLanguage = (selectedLanguage) => {
    i18n.changeLanguage(selectedLanguage);
    localStorage.setItem("preferredLanguage", selectedLanguage);
  };
  useEffect(() => {
    if (lastSegment === "es") {
      i18n.changeLanguage("es");
    } else {
      const languageProfile = ["es", "en"].includes(
        localStorage.getItem("preferredLanguage")
      )
        ? localStorage.getItem("preferredLanguage")
        : null;
      if (
        typeof languageProfile !== "undefined" &&
        languageProfile !== null &&
        languageProfile !== ""
      ) {
        i18n.changeLanguage(languageProfile);
      } else {
        i18n.changeLanguage("en");
      }
    }
  }, [i18n]);
  const redesign = process.env.REACT_APP_REDESIGN;
  const loginURL =
    redesign === "true"
      ? isKiosko
        ? "/auth/login-customer/kiosko/" + lastSegment
        : isAgent
        ? "/auth/login-agent"
        : "/auth/login-customer"
      : "/auth/login-page";
  const [open, setOpen] = React.useState(false);
  const menuItemsAgent = isAgent
    ? [t("home.menuClients"), t("home.menuSavedQuotes"), t("home.menuPolicies")]
    : [];
  const menuItemProfile = !isAgent ? [t("home.menuProfile")] : [];
  const menuItems = [
    t("home.menuHome"),
    t("home.menuQuote"),
    ...menuItemProfile,
    ...menuItemsAgent,
    t("home.menuResources"),
  ];

  const currentUrl = window.location.pathname;
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return window.location.href.indexOf(routeName) > -1 ? true : false;
  };
  const classes = useStyles();
  const collapseItemMini = classes.collapseItemMini + " ";
  const appBarClasses = cx({
    [" " + classes[color]]: color,
  });
  const phpSystem = process.env.REACT_APP_PHP_SYSTEM;
  let menuAdminItems = [{ label: "Reports", url: "/admin/reports" }];
  if (userType == "1") {
    menuAdminItems.push({ label: "Agencies", url: "/admin/agencies" });
    menuAdminItems.push({ label: "Users", url: "/admin/users" });
    menuAdminItems.push({ label: "Rates", url: "/admin/rates" });
    menuAdminItems.push({ label: "News", url: "/admin/news" });
    menuAdminItems.push({
      label: "Bluefire Transactions",
      url: "/admin/transactionsLists",
    });
    menuAdminItems.push({
      label: "Makes and Models",
      url: "/admin/makesModels",
    });
  }
  var list = (
    <List className={classes.list}>
      {isAgent && (
        <ListItem className={classes.listItem}>
          <MenuButton
            notifications={menuAdminItems}
            menuButtonLabel={"Admin"}
            onItemClick={(n) => console.log("Click:", n)}
            className={classes.menuBarButton}
          />
        </ListItem>
      )}
      <ListItem className={classes.listItem}>
        <ListItem className={`${classes.listItem}`}>
          <div
            className={classes.navLink}
            onClick={() => changeLanguage(i18n.language === "es" ? "en" : "es")}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
            }}
          >
            {i18n.language === "es" ? (
              <img
                src={usFlag}
                alt="US Flag"
                style={{ width: "24px", height: "16px" }}
              />
            ) : (
              <img
                src={mexFlag}
                alt="Mexico Flag"
                style={{ width: "24px", height: "16px" }}
              />
            )}
            {i18n.language === "es" ? "EN" : "ES"}
          </div>
        </ListItem>
      </ListItem>
      <ListItem className={classes.listItem}>
        <a
          href={"https://www.sanborns.com/contact-us"}
          target="_blank"
          className={classes.navLink}
        >
          <FAQIcon className={classes.listItemIcon} />
        </a>
      </ListItem>
      <ListItem className={classes.listItem}>
        {localStorage.getItem("userToken") === null ? (
          <NavLink
            to={
              isKiosko
                ? "/auth/login-customer/kiosko/" + lastSegment
                : "/auth/login-customer"
            }
            className={cx(classes.navLink, {
              [classes.navLinkActive]: activeRoute("/auth/login-customer"),
            })}
          >
            <Person className={classes.listItemIcon} />
            <ListItemText
              primary={
                localStorage.getItem("userToken") === null
                  ? t("navbar.log_in")
                  : userName
              }
              disableTypography={true}
              className={classes.listItemText}
            />
          </NavLink>
        ) : (
          <MenuButton
            notifications={[
              {
                label: "My Profile",
                url: "/admin/profile",
              },
              {
                label: t("navbar.log_out"),
                url: "#",
                onClick: () => {
                  localStorage.clear();
                  const logoutURL = isKiosko
                    ? "/auth/login-customer/kiosko/" + lastSegment
                    : "/auth/login-customer";
                  window.location.href = logoutURL;
                },
              },
            ]}
            menuButtonLabel={
              <>
                <Person className={classes.listItemIcon} />
                <ListItemText
                  primary={
                    localStorage.getItem("userToken") === null
                      ? t("navbar.log_in")
                      : userName
                  }
                  disableTypography={true}
                  className={classes.listItemText}
                />
              </>
            }
            onItemClick={(n) => console.log("Click:", n)}
            className={classes.menuBarButton}
          />
        )}
      </ListItem>
      {isAgent && (
        <ListItem className={classes.listItem}>
          <a
            href={phpSystem}
            target="_blank"
            className={cx(classes.navLink, {
              [classes.navLinkActive]: false,
            })}
            rel="noopener noreferrer"
          >
            <ListItemText
              primary={t("navbar.home")}
              disableTypography={true}
              className={classes.listItemText}
            />
          </a>
        </ListItem>
      )}
    </List>
  );
  var listNormal = (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <div>
          <Language className={classes.listItemIcon} />
          <CustomSelect
            menuItems={[
              { value: "en", label: "English" },
              { value: "es", label: "Español" },
            ]}
            formControlProps={{
              fullWidth: false,
              className: "languageStyle",
            }}
            inputProps={{
              value: i18n.language,
              onChange: handleLanguageChange,
            }}
          />
        </div>
      </ListItem>
      <ListItem className={classes.listItem}>
        <NavLink to={"/admin/dashboard"} className={classes.navLink}>
          <Phone className={classes.listItemIcon} />

          <ListItemText
            primary={t("navbar.call_us")}
            disableTypography={true}
            className={classes.listItemText}
          />
          <span> 800-222-0158</span>
        </NavLink>
      </ListItem>
      <ListItem className={classes.listItem}>
        <NavLink
          to={
            isKiosko
              ? "/auth/login-customer/kiosko/" + lastSegment
              : "/auth/login-customer"
          }
          className={cx(classes.navLink, {
            [classes.navLinkActive]: activeRoute("/auth/login-customer"),
          })}
        >
          <Person className={classes.listItemIcon} />
          <ListItemText
            primary={
              localStorage.getItem("userToken") === null
                ? t("navbar.log_in")
                : t("navbar.log_out")
            }
            disableTypography={true}
            className={classes.listItemText}
          />
        </NavLink>
      </ListItem>
      {isAgent && (
        <ListItem className={classes.listItem}>
          <a
            href={phpSystem}
            target="_blank"
            className={cx(classes.navLink, {
              [classes.navLinkActive]: false,
            })}
            rel="noopener noreferrer"
          >
            <ListItemText
              primary={t("navbar.home")}
              disableTypography={true}
              className={classes.listItemText}
            />
          </a>
        </ListItem>
      )}
    </List>
  );
  var listSmall = localStorage.getItem("sale") !== "true" && (
    <List className={`${classes.list} ${classes.listFlex}`} dense>
      {isAgent && (
        <ListItem className={classes.listItem}>
          <MenuButton
            notifications={menuAdminItems}
            menuButtonLabel={"Admin"}
            onItemClick={(n) => console.log("Click:", n)}
            className={classes.menuBarButton}
          />
        </ListItem>
      )}
      <ListItem
        className={`${classes.listItem}`}
        style={{ marginRight: "20px" }}
      >
        <div
          className={classes.navLink}
          onClick={() => changeLanguage(i18n.language === "es" ? "en" : "es")}
          style={{ display: "flex", alignItems: "center", gap: "8px" }}
        >
          <Language className={classes.listItemIcon} />

          {i18n.language === "es" ? "EN" : "ES"}
        </div>
      </ListItem>
      <ListItem className={`${classes.listItemFlex} ${classes.listItem}`}>
        <a
          href={"https://www.sanborns.com/contact-us"}
          target="_blank"
          className={classes.navLink + " " + classes.noPadding}
        >
          <FAQIcon className={classes.listItemIcon} />
        </a>
      </ListItem>
      {localStorage.getItem("userToken") === null && (
        <ListItem className={classes.listItem}>
          <NavLink
            to={
              isKiosko
                ? "/auth/login-customer/kiosko/" + lastSegment
                : "/auth/login-customer"
            }
            className={cx(classes.navLink, classes.noPadding, {
              [classes.navLinkActive]: activeRoute("/auth/login-customer"),
            })}
          >
            <Person className={`${classes.listItemIcon}`} />
          </NavLink>
        </ListItem>
      )}
      {localStorage.getItem("userToken") !== null && (
        <ListItem className={classes.listItem}>
          <NavLink
            to={"#"}
            className={cx(classes.navLink, classes.noPadding, {
              [classes.navLinkActive]: activeRoute("/auth/login-customer"),
            })}
            onClick={handleDrawerToggle}
          >
            <ListIcon className={`${classes.listItemIcon}`} />
          </NavLink>
        </ListItem>
      )}
    </List>
  );

  const checkFreewayStyle = () => {
    let freewayStyle = "";
    if (agencyType == "Freeway") {
      freewayStyle = " freeway-style-redesign";
      if (isXs || isSm) {
        (" freeway-style-redesign-mobile");
      }
    }
    return freewayStyle;
  };

  const freewayStyle = checkFreewayStyle();

  const redirectLogin = () => {
    localStorage.clear();
    window.location.href = loginURL;
  };

  const checkActiveTab = (item) => {
    const itemName = item.toLowerCase().replace("ó", "o");
    return (
      currentUrl === "/guest/" + itemName ||
      (["/guest/es", "/guest/en", "/admin/summary"].some((url) =>
        currentUrl.includes(url)
      ) &&
        (item == "Quote" || itemName == "cotizacion")) ||
      currentUrl === "/admin/" + itemName ||
      (itemName == "inicio" && currentUrl === "/admin/home") ||
      (itemName == "recursos" && currentUrl === "/admin/resources") ||
      (itemName == "perfil" && currentUrl === "/admin/profile") ||
      (itemName == "polizas" && currentUrl === "/admin/policies") ||
      (itemName == "Cotizaciones guardadas" &&
        currentUrl === "/admin/savedQuotes") ||
      (itemName == "clientes" && currentUrl === "/admin/clients")
    );
  };

  const redirectUrlMenu = (nameItem) => {
    nameItem = nameItem.replace("ó", "o");
    const urlList = {
      home: "/admin/home",
      quote: "/guest/en",
      resources: "/admin/resources",
      profile: "/admin/profile",
      policies: "/admin/policies",
      "saved quotes": "/admin/savedQuotes",
      clients: "/admin/clients",
      inicio: "/admin/home",
      cotizacion: "/guest/es",
      recursos: "/admin/resources",
      perfil: "/admin/profile",
      polizas: "/admin/policies",
      "cotizaciones guardadas": "/admin/savedQuotes",
      clientes: "/admin/clients",
    };
    return urlList[nameItem];
  };

  return (
    <>
      {isInactive && localStorage.getItem("userToken") !== null
        ? redirectLogin()
        : ""}
      {localStorage.getItem("sale") !== "true" &&
        !pathName.includes("/admin/policyPdf") && (
          <AppBar position="static" className={classes.appBar + freewayStyle}>
            <Toolbar className={classes.container}>
              <div className={classes.flex}>
                <img
                  src={logoList[agencyType]}
                  alt="Sanborn's Mexico Auto Insurance"
                  className={
                    classes.styleLogo +
                    (agencyType == "Freeway" ? " " + classes.freewayLogo : "")
                  }
                  onClick={() => {
                    if (agencyType != "Freeway") {
                      window.open("https://www.sanborns.com");
                    }
                  }}
                />
                {agencyType == "Freeway" && (
                  <img
                    src={logoList["Sanborns"]}
                    alt="Sanborn's Mexico Auto Insurance"
                    className={classes.sanbornsFreewayLogo}
                    onClick={() => {
                      window.open("https://www.sanborns.com");
                    }}
                  />
                )}
              </div>
              <Hidden smDown>
                {["/guest", "/admin"].some((url) => currentUrl.includes(url)) &&
                  localStorage.getItem("userToken") !== null && (
                    <div className={classes.menuContainer}>
                      <ul className={classes.menu}>
                        {menuItems.map((item, index) => (
                          <li
                            key={item}
                            className={
                              classes.menuItem +
                              " " +
                              (checkActiveTab(item) ? classes.activeItem : {})
                            }
                            onClick={() =>
                              (window.location.href = redirectUrlMenu(
                                item.toLowerCase()
                              ))
                            }
                          >
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                {list}
              </Hidden>
              <Hidden mdUp>{listSmall}</Hidden>
            </Toolbar>
          </AppBar>
        )}
    </>
  );
}

AuthNavbar.propTypes = {
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  brandText: PropTypes.string,
};
